import { BasicInfo, Dest, ShippingDetail, TimeLine, TimeLineItem } from '@/types/result';
import * as df from 'date-fns';
import numeral from 'numeral';
import * as _ from 'lodash';

export const isEmptyString = (str: string): boolean => {
  let retVal = false;
  if (str && str.length > 0) {
    switch (str) {
      case 'N/A':
      case 'n/a':
      case 'null':
        retVal = false;
        break;
      default:
        retVal = true;
        break;
    }
  }

  return retVal;
};

export const distanceStringMeterToKm = (str: string | number): string => {
  if (typeof str === 'string') str = Number(str);
  let res = numeral(str).divide(1000).format('0,0.0');
  return str !== 0 ? res + 'km' : '--';
};

export const secondsToTimestamp = (str: string | number): string => {
  if ((str === '--' || !str) && str !== 0) return '--';
  const num = Number(str);
  const seconds = num % 60;
  const minutes = ((num - seconds) % (60 * 60)) / 60;
  const hours = (num - seconds - minutes * 60) / (60 * 60);

  return str !== 0 ? `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}` : '--';
};

export const timeStringtoSecond = (str: string): number => {
  const tArr = str.split(':');
  return Number(tArr[0]) * 3600 + Number(tArr[1]) * 60 + Number(tArr[2]);
};

export const createTimelineMin = (basicInfo: BasicInfo, shippingList: ShippingDetail[]): TimeLine[] => {
  if (basicInfo && shippingList) {
    const timeLineLength = getTimelineLength(basicInfo.timeLine.timelineLength);
    const startTime = basicInfo.timeLine.startHour;

    const originList: TimeLine[] = shippingList.map((shippingDetail: ShippingDetail, slIndex: number) => {
      const timeLine: any[] = [];
      const color = shippingDetail.color;
      const car = shippingDetail.car;

      for (var timeIndex = 0; timeIndex < timeLineLength; timeIndex++) {
        const timeFrom = df.add(startTime, { seconds: timeIndex * 60 });
        const timeTo = df.add(startTime, { seconds: (timeIndex + 1) * 60 - 1 });
        const targetItem = shippingDetail.destList?.find((fItem: Dest) => {
          const retVal = df.isWithinInterval(df.parse(fItem.arrivalTime, 'HH:mm', new Date()), {
            start: timeFrom,
            end: timeTo,
          });
          return retVal;
        });
        const obj: TimeLineItem = {
          index: slIndex + '_' + timeIndex,
          color,
          car,
          from: df.format(timeFrom, 'HH:mm:ss'),
          to: df.format(timeTo, 'HH:mm:ss'),
          target: targetItem,
        };
        if (targetItem) {
          timeIndex += (targetItem.dwellTime.value ? targetItem.dwellTime.value / 60 : 1) - 1;
        }
        timeLine.push(obj);
      }
      const { destList, destLength, orderLength } = getTimeLineDestInfo(timeLine);
      return {
        index: slIndex,
        car,
        color,
        destList,
        destLength,
        orderLength,
        distance: shippingDetail.distance,
        time: shippingDetail.time,
        route: shippingDetail.route,
        reverse: shippingDetail.reverse,
        timelineList: timeLine,
      };
    });
    return originList;
  }
};

export const getTimeLineDestInfo = (
  timeLine: TimeLineItem[],
): { destList: Dest[]; destLength: number; orderLength: number } => {
  if (timeLine && timeLine.length > 0) {
    const temp: TimeLineItem[] = timeLine.filter((v: TimeLineItem) => v.target);
    const destList: Dest[] = _.map(temp, (v: TimeLineItem) => {
      return v.target;
    });

    return {
      destList,
      destLength: destList.length,
      orderLength: _.sumBy(destList, (v) => v.orderInfo?.length),
    };
  }
};

export const createTimeBase = (start: Date, end: Date, interval: number): any[] => {
  const retArr: any[] = [];
  if (start && end && interval) {
    let time = start;
    while (time < end) {
      retArr.push(time);
      time = df.add(time, { minutes: interval });
    }
  }
  return retArr;
};

export const getTimelineLength = (len: number) => {
  return len > 15 ? len : 16;
};

export const nearXFiveZeroMin = (param: Date): Date => {
  const min = df.getMinutes(param).toString();
  let toEndNum = Number(min[min.length - 1]);
  if (toEndNum !== 5) {
    toEndNum -= toEndNum > 5 ? toEndNum % 5 : toEndNum;
  }
  const calMin = min.length > 1 ? min[0] + toEndNum : toEndNum;
  param.setMinutes(Number(calMin));
  param.setSeconds(0);
  return param;
};

export const destListCarSeqUpdate = (destList: any[], targetId: number, updateCarSeq: number | null): any[] => {
  const retArr: any[] = _.map(destList, (v) => {
    if (v.seq !== targetId) {
      return v;
    } else {
      return {
        ...v,
        r_car_seq: updateCarSeq,
      };
    }
  });
  return retArr;
};
